import React, { useState } from 'react';
import { Button as But, IconButton as IBut, CircularProgress, Icon, Menu, MenuItem, Tooltip } from '@material-ui/core';
import Colors from '../../styles/colors';
import useStyles from './styles';
import { merge, get } from 'global/lib/lodash';

export const Button = (props) => {
  const bgColor = props.bgColor || props.color || Colors.blue;
  const classes = useStyles({ ...props, bgColor: bgColor == 'default' ? Colors.defaultGrey : bgColor });
  const clss = merge({}, classes, props.classes);
  const [loading, setLoading] = useState(false);
  const { isLoading, ...rest } = props;

  const onClick = async (e) => {
    try {
      setLoading(true);
      props.onClick && (await props.onClick(e));
    } finally {
      setLoading(false);
    }
  };

  const ico = (() => {
    const icoobj = props.startIcon || props.icon;
    if (typeof icoobj === 'string') {
      return <Icon>{icoobj}</Icon>;
    }
    return icoobj;
  })();

  return (
    <But {...rest} variant={props.variant === 'none' ? undefined : "contained"} startIcon={ico} onClick={onClick} classes={clss}>
      {props.title || props.children}
      {(props.loading || loading) && <CircularProgress size={12} />}
    </But>
  );
};

export const IconButton = (props) => {
  const [loading, setLoading] = useState(false);
  const { isLoading, ...rest } = props;

  const bgColor = props.bgColor || props.color || 'default';
  const classes = useStyles({ ...props, bgColor: bgColor == 'default' ? Colors.defaultGrey : bgColor });
  const clss = merge({}, classes, props.classes);

  const onClick = async (e) => {
    try {
      setLoading(true);
      props.onClick && (await props.onClick(e));
    } finally {
      setLoading(false);
    }
  };

  const ico = (() => {
    const icoobj = props.startIcon || props.icon;
    if (typeof icoobj === 'string') {
      return <Icon>{icoobj}</Icon>;
    } else if (icoobj) {
      return icoobj;
    }
    return props.children;
  })();

  const Comp = (
    <IBut {...rest} startIcon={ico} onClick={onClick} classes={clss}>
      {(props.loading || loading) ? <CircularProgress size={12} /> : ico}
    </IBut>
  );

  if (rest.toolTip) {
    return (
      <Tooltip title={rest.toolTip}>
        <span>
          {Comp}
        </span>
      </Tooltip>
    )
  }

  return Comp;
};

export const ButtonDrop = (props) => {
  const [state, setState] = useState({
    anchor: null,
  });

  const onClick = (e) => {
    setState((s) => ({ ...s, anchor: e.target }));
  };

  const onClose = () => {
    setState((s) => ({ ...s, anchor: null }));
  };

  const onSelect = (opt) => {
    props.onSelect && props.onSelect(opt);
    onClose();
  };

  const opts = get(props, 'options', []);

  return (
    <>
      <Button {...props} onClick={onClick} />
      <Menu id="simple-menu" anchorEl={state.anchor} keepMounted open={Boolean(state.anchor)} onClose={onClose}>
        {opts.map((opt, i) => (
          <MenuItem {...opt} onClick={() => onSelect(opt)}>
            {opt.title || opt.children}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
